import { ActionIcon as MantineActionIcon } from '@mantine/core';

export const ActionIcon = MantineActionIcon.extend({
	defaultProps: {
		variant: 'primary',
	},
});
